import { styled } from '@air/marketing-primitives';

export const Avatar = styled('div', {
  position: 'relative',
  paddingBottom: '86%',
  filter: 'grayscale(1)',
  transition: 'filter 0.2s ease',
});

export const Logo = styled('div', {
  position: 'relative',
  height: 16,
  marginTop: 4,
  marginBottom: 12,
  filter: 'grayscale(1)',
  transition: 'filter 0.2s ease',
});

export const Root = styled('a', {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '$pigeon025',
  borderRadius: 8,
  border: '1px solid $colors$pigeon050',
  textDecoration: 'none',
  overflow: 'hidden',
  transition: 'box-shadow 0.2s ease',
  cursor: 'pointer',

  '&:hover': {
    boxShadow: '0 4px 4px rgba(0, 0, 0, 0.25)',

    [`& ${Avatar}, & ${Logo}`]: {
      filter: 'grayscale(0)',
    },
  },
});

export const Meta = styled('div', {
  zIndex: 1,
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  backgroundColor: '$white',
  padding: 12,
  borderTop: '1px solid $colors$pigeon050',
});

export const StyledOperatorCard = {
  Avatar,
  Logo,
  Meta,
  Root,
};
